/**
 * @desc 페이지 경로를 GTM(Google Tag Manager)으로 전송
 * @param {string} path 전송할 페이지 경로
 */
export const sendPageViewToGTM = (path) => {
  // GTM의 dataLayer 배열이 존재하지 않으면 빈 배열로 초기화
  window.dataLayer = window.dataLayer || [];

  // GTM dataLayer에 페이지 뷰 이벤트를 전송
  window.dataLayer.push({
    event: "pageview", // 이벤트 이름을 'pageview'로 설정
    page: path, // 전송할 경로 정보를 page 필드에 설정
  });
};

/**
 * @desc 클릭 이벤트를 GTM(Google Tag Manager)으로 전송
 * @param {string} url 클릭된 요소의 URL
 * @param {string} title 클릭된 요소의 제목 또는 타겟 정보
 */
export const handleClickToGTM = (url, title) => {
  // GTM의 dataLayer 배열이 존재하지 않으면 빈 배열로 초기화
  window.dataLayer = window.dataLayer || [];

  // GTM dataLayer에 클릭 이벤트를 전송
  window.dataLayer.push({
    event: "ClickEvent", // 사용자 정의 이벤트 이름
    "gtm.elementUrl": url, // 클릭된 URL을 gtm.elementUrl 필드에 설정
    "gtm.elementTarget": title, // 클릭된 요소의 제목 또는 타겟 정보를 gtm.elementTarget 필드에 설정
  });
};

export const clickToGTM = ({ target, id, url }) => {
  // GTM의 dataLayer 배열이 존재하지 않으면 빈 배열로 초기화
  window.dataLayer = window.dataLayer || [];

  // GTM dataLayer에 클릭 이벤트를 전송
  window.dataLayer.push({
    event: "ClickEvent", // 사용자 정의 이벤트 이름
    "gtm.elementUrl": url ?? "", // 클릭된 URL을 gtm.elementUrl 필드에 설정
    "gtm.elementTarget": target ?? "", // 클릭된 요소의 제목 또는 타겟 정보를 gtm.elementTarget 필드에 설정
    "gtm.elementId": id ?? "",
  });
};

/**
 * @desc 주어진 경로에 따라 특정 클래스 이름을 반환
 * @param {string} path 페이지 경로
 * @returns {string} 경로에 따른 클래스 이름
 */
export const classNameToGTM = (path) => {
  if (path === undefined) {
    return "";
  } else if (path.includes("docs")) {
    // 경로에 'docs'가 포함된 경우
    return "docs";
  } else if (path.includes("android")) {
    // 경로에 'android'가 포함된 경우
    return "android";
  } else if (path.includes("ios")) {
    // 경로에 'ios'가 포함된 경우
    return "ios";
  } else if (path.includes("/")) {
    // 그 외의 경우, 첫 번째 '/' 이후의 문자열을 반환
    return path.substring(path.indexOf("/") + 1);
  } else {
    return path;
  }
};
